
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesMasterGrid extends Serenity.EntityGrid<SalesMasterRow, any> {
        protected getColumnsKey() { return 'Sales.SalesMaster'; }
        protected getDialogType() { return SalesMasterDialog; }
        protected getIdProperty() { return SalesMasterRow.idProperty; }
        protected getInsertPermission() { return SalesMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesMasterRow.localTextPrefix; }
        protected getService() { return SalesMasterService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            
            var voucherNo = FormatHelper.GetVoucherNo(19);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[19].AutoPosting;

            this.editItem(<SalesMasterRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                VoucherTypeId: 19,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: new Date().toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
          //  this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}